import $ from "jquery";

/**
* implements modal listeners and additional functionalities
*
*/
export function initModal() {
  // logic and listeners here
  const $modalOpeners = $('[data-modal-id]');
  const $modalBackgrounds = $('div.custom-modal__bg');
  const $modalClose = $('.close-modal a');
  const $overlayOpener = $('.cm-cta-button--overlay');

  $modalOpeners.on('click', ev => {
    ev.preventDefault();
    $(ev.currentTarget).addClass('modal-opened');
    const $targetModal = $('#' + ev.currentTarget.dataset.modalId);

    $targetModal.addClass('opened');
    $('body').addClass('modal-opened');

    $targetModal.find('button, a, input, [tabindex]').first().focus();
  });

  $modalBackgrounds.on('click', ev => {
    const $openedModal = $(ev.currentTarget).closest('.custom-modal');

    $openedModal.removeClass('opened');

    $('.modal-opened').focus();

    $('.modal-opened').removeClass('modal-opened');
  });

  $modalClose.on('click', ev => {
    ev.preventDefault();
    const $openedModal = $(ev.currentTarget).closest('.custom-modal');

    $openedModal.removeClass('opened');
    $('#htmlModal .content-container').children().remove();

    $('.modal-opened').focus();

    $('.modal-opened').removeClass('modal-opened');
    $('body').removeClass('modal-opened');
  });

  $overlayOpener.on('click', ev => {
    ev.preventDefault();
    $(ev.currentTarget).addClass('modal-opened');
    $('body').addClass('modal-opened');
    const dataSrc = $(ev.currentTarget).attr('href');

    $('#htmlModal .content-container').load(dataSrc + ' main > section:not(".noOverlay")', () => {
      $(window).trigger('resize');
      loadSVGs('#htmlModal .content-container');
      equalHeight($('#htmlModal .content-container'));
      initCollapse();
      initTables();
      initProductDetails();
      initSearch();
      window.setTimeout(() => {
        $('#htmlModal').focus();
      }, 500 );
    });

    $('#htmlModal').addClass('opened');
  });

  $(document).keyup((ev) => {
    if (ev.keyCode === 27) {
      $modalClose.trigger('click');
    }
  });
}